<script>

    import ModalContainer from '../$components/modal.container.svelte'

    import PrepaidCreateComponent from './component.create.svelte'
    import PrepaidsComponent from './component.prepaids.svelte'
    import PrepaidComponent from './component.prepaid.svelte'
    import PrepaidUpdateComponent from './component.update.svelte'

    import ButtonModal from '../$components/button.modal.svelte'

    import TitleHero from '../$components/title.hero.svelte'
    import View from '../$layouts/view.layout.svelte'

</script>

<View>
    <div>
        <TitleHero title="Prepagos" subtitle="Consulta y gestión de prepagos" />
        <PrepaidsComponent />
    </div>
</View>

<ModalContainer id="prepaid_create_modal" title="Crear prepago" >
    <PrepaidCreateComponent />
</ModalContainer>

<ModalContainer id="prepaid_modal" title="Prepago" >
    <PrepaidComponent />
</ModalContainer>

<ModalContainer id="prepaid_update_modal" title="Prepago" >
    <PrepaidUpdateComponent showTitle={false} />
</ModalContainer>